import { render, staticRenderFns } from "./ScreensaverListTab.vue?vue&type=template&id=3b799d63"
import script from "./ScreensaverListTab.vue?vue&type=script&lang=js"
export * from "./ScreensaverListTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports